import { FINANCIAL_EDUCATION_JOURNEY_CREATE, JOURNEY_ITEM_UPDATE } from "../../../actions/financialEducation/journey";

export const isFinancialEducation = action => (
    action.type === FINANCIAL_EDUCATION_JOURNEY_CREATE ||
    action.type === JOURNEY_ITEM_UPDATE
)
